import { Component, OnInit, Input, Output, ViewChild, EventEmitter, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToastService } from '../../../shared/providers/toast.service';
import { AuthenticationService } from '../../../shared/auth/authentication.service';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { LoaderService } from '../../../shared/providers/loader.service';
import { HttpClient } from '@angular/common/http';
import { DataTablesResponse } from '../../../shared/models/datatables-response';
import { environment } from '../../../../environments/environment';
import { OfferService } from '../../../shared/providers/offer.service';
import { ValidationService } from '../../../shared/providers/validation.service';

interface IExternalBroker {
    Id: number;
    FirstName: string;
    LastName: string;
    Phone: string;
    Email: string;
    ProfilePic: string;
    Company: string;
}

@Component({
    selector: 'app-external-broker-selection',
    templateUrl: './external-broker-selection.component.html'
})
export class ExternalBrokerSelectionComponent implements OnInit {

    constructor(private _offerService: OfferService, private Validation: ValidationService, private _toastService: ToastService, private Loader: LoaderService, private http: HttpClient, private modalService: BsModalService, private authService: AuthenticationService) { }

    @Input() modalRef: BsModalRef;
    @Input() PropertyId: number;
    @Output() close = new EventEmitter();
    dtOptions = {};
    table: DataTableDirective;
    protected readonly BASE_URL: string = environment.base_url;
    users: IExternalBroker[];
    @ViewChild(DataTableDirective) dtElement: DataTableDirective;
    @Output() selectedUser = new EventEmitter();
    searchValue = "";
    ngOnInit() {
        const that = this;
        let TableColums =
            [{ data: 'ID' },

            ];
        this.dtOptions = {
            pagingType: 'full_numbers',
            serverSide: true,
            processing: true,
            info: false,
            language: {
                zeroRecords: null,
            },
            "pageLength": 10,
            bLengthChange: false,
            initComplete: () => $('.dataTables_filter').css('display', 'none'),
            ajax: (dataTablesParameters: any, callback: Function) => {
                //dataTablesParameters.Extra_param = filter;
                //dataTablesParameters.Extra_param.StatusId = this.statusId;

                const httpHeader = this.Validation.GetAuthHeader();

                that.http
                    .post<DataTablesResponse>(
                        this.BASE_URL + '/opportunity/GetExternalBrokerList/',
                        dataTablesParameters, httpHeader
                    ).subscribe(resp => {
                        $(".dataTables_wrapper table thead").hide();
                        that.users = resp.data ? resp.data : [];
                        if (resp) {
                            callback({
                                recordsTotal: resp.recordsTotal,
                                recordsFiltered: resp.recordsFiltered,
                                data: []
                            });
                            if (resp.data.length === 0) {
                                $(".dataTables_paginate.paging_full_numbers").hide();
                            }
                            else {
                                $(".dataTables_paginate.paging_full_numbers").show();
                            }
                            $(".paginate_button.first,.paginate_button.last").hide();
                        } else {
                            callback({
                                recordsTotal: 0,
                                recordsFiltered: 0,
                                data: []
                            });
                            $(".dataTables_paginate.paging_full_numbers").hide();
                        }
                    });
            },
            columns: TableColums
        };
    }
    searchExchange(text: string) {
        this.dtElement.dtInstance.then(x => x.search(text).draw());
    }

    onUserSelect(user: any) {
        this.modalRef.hide();
        this.selectedUser.emit(user);
    }
}
